export const experienceEntries = [
  {
    company: "AlertMFB",
    role: "Senior Frontend Engineer",
    dates: "January 2026 – Present",
    summary: "Lead frontend implementation across enterprise banking, investment and employee-management products, coordinating delivery from requirements through production.",
    bullets: [
      "Designed and built the complete AlertEvaluate frontend from requirements through production delivery using Next.js, React, TypeScript and Tailwind CSS; integrated separately built backend APIs for employee, manager and HR workflows.",
      "Maintain and expand Business Central across banking, POS, credit, approvals, access control and operational administration.",
      "Build Bucks Invest partner workflows covering KYB onboarding, investment products, analytics, reporting and administration.",
      "Develop reusable frontend architecture, integrate REST APIs and mentor two junior frontend developers.",
    ],
    tech: ["React", "Next.js", "TypeScript", "TanStack Query", "Zustand"],
  },
  {
    company: "UniswitchNg",
    role: "Frontend Engineer",
    dates: "January 2023 – December 2025",
    summary: "Built fintech and workforce-management interfaces in collaboration with backend engineers.",
    bullets: [
      "Contributed to Sarepay Checkout, BillerHQ and HRDesk product experiences.",
      "Implemented role-based dashboards, payment workflows and REST API integrations.",
      "Handled server-state, caching, loading, empty and error states across operational interfaces.",
    ],
    tech: ["React", "Next.js", "Vue", "REST APIs", "State Management"],
  },
  {
    company: "Tech Citadel",
    role: "Frontend Developer",
    dates: "September 2024 – January 2025",
    summary: "Delivered reusable, responsive frontend systems and worked with design and product requirements across web experiences.",
    bullets: [
      "Built reusable interface components and consistent interaction patterns.",
      "Worked on responsive implementation, performance and component architecture.",
      "Collaborated across design and engineering hand-offs.",
    ],
    tech: ["React", "Next.js", "Tailwind CSS", "Component Systems"],
  },
  {
    company: "Bincom Dev Center",
    role: "Frontend Developer",
    dates: "January 2021 – December 2022",
    summary: "Built cross-platform interfaces and reusable components while collaborating on API-connected delivery workflows.",
    bullets: [
      "Worked with React, Vue, Angular and TypeScript across web and hybrid interfaces.",
      "Integrated REST APIs and contributed to reusable frontend architecture.",
      "Supported code review, CI/CD practices and junior developer guidance.",
    ],
    tech: ["React", "Vue", "Angular", "TypeScript", "REST APIs"],
  },
];
